// https://www.transparenttextures.com/

// Store these in /public/textures so you can build the URL easily

export default [
  "45-degree-fabric-dark.png",
  "45-degree-fabric-light.png",
  "absurdity.png",
  "always-grey.png",
  "arches.png",
  "asfalt-dark.png",
  "asfalt-light.png",
  "asphalt-dark.png",
  "beige-paper.png",
  "binding-dark.png",
  "binding-light.png",
  "black-felt.png",
  "black-linen-2.png",
  "black-paper.png",
  "blizzard.png",
  "brick-wall-dark.png",
  "brick-wall.png",
  "bright-squares.png",
  "brushed-alum-dark.png",
  "brushed-alum.png",
  "buried.png",
  "cardboard-flat.png",
  "cardboard.png",
  "church.png",
  "clean-gray-paper.png",
  "concrete-wall-2.png",
  "concrete-wall-3.png",
  "cream-paper.png",
  "cross-scratches.png",
  "dark-leather.png",
  "diagonales-decalees.png",
  "fabric-of-squares.png",
  "french-stucco.png",
  "gradient-squares.png",
  "grid.png",
  "grunge-wall.png",
  "large-leather.png",
  "light-paper-fibers.png",
  "light-sketch.png",
  "lined-paper-2.png",
  "mocha-grunge.png",
  "paper-fibers.png",
  "texturetastic-gray.png"
];
